import { useImperativeHandle, useState, forwardRef } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, find, noop } from 'lodash';
import SelectField from "../../Form/SelectField/SelectField";
import Icon from "../Icon/Icon";
import "./ActionSelect.scss";
import { jsx as _jsx } from "react/jsx-runtime";
const ActionSelect = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    position = 'right',
    actions = [],
    disabled = false,
    flat = true,
    id,
    placeholder = 'Take Action',
    label = 'Action Select',
    primary = true,
    searchEnabled = false,
    styles = {},
    valueKey = 'value',
    labelKey = 'label',
    onChange = noop,
    'data-testid': dataTestId
  } = _ref;
  const [loading, setLoading] = useState(false);
  const [selectedAction, setSelectedAction] = useState(null);
  const options = actions.map(action => ({
    ...action,
    ...(action.icon ? {
      icon: /*#__PURE__*/_jsx(Icon, {
        icon: action.icon,
        className: "mr-1 mb-1"
      })
    } : null),
    ...(action.description ? {
      description: /*#__PURE__*/_jsx("p", {
        className: `text-xs text-dark-grey font-regular-font ${action.icon && 'ml-6'}`,
        children: action.description
      })
    } : null)
  }));
  const doAction = action => {
    if (typeof action.action === 'function') {
      setLoading(true);
      const p = action.action();
      Promise.all([p]).then(() => {
        setLoading(false);
      });
    }
  };
  const handleOnChange = val => {
    const action = find(actions, act => act.value === val);
    const selected = isEmpty(action) ? null : action;
    setSelectedAction(selected);
    setTimeout(() => doAction(action), 400);
    onChange(selected);
  };

  // Expose a resetValue method to the parent component
  useImperativeHandle(ref, () => ({
    resetValue: () => setSelectedAction(null)
  }));
  return /*#__PURE__*/_jsx("div", {
    className: `action-select-container ${position}`,
    children: /*#__PURE__*/_jsx("div", {
      className: `flex text-xs font-heavy-font ${!flat ? 'shadow' : ''}`,
      children: /*#__PURE__*/_jsx(SelectField, {
        tabIndex: 0,
        id: id,
        "data-testid": dataTestId,
        options: options,
        disabled_prop: loading || disabled,
        loading: loading,
        className: "p-0",
        placeholder: placeholder,
        onChange: handleOnChange,
        searchEnabled: searchEnabled,
        style: styles,
        label: label,
        hideLabel: true,
        valueKey: valueKey,
        labelKey: labelKey,
        value: selectedAction,
        primary: primary
      })
    })
  });
});
ActionSelect.propTypes = {
  actions: PropTypes.array,
  position: PropTypes.oneOf(['right', 'left']),
  disabled: PropTypes.bool,
  flat: PropTypes.bool,
  id: PropTypes.string.isRequired,
  labelKey: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.node,
  label: PropTypes.string,
  primary: PropTypes.bool,
  styles: PropTypes.shape({
    container: PropTypes.object,
    label: PropTypes.object,
    input: PropTypes.object,
    hint: PropTypes.object,
    error: PropTypes.object
  }),
  searchEnabled: PropTypes.bool,
  valueKey: PropTypes.string,
  'data-testid': PropTypes.string
};
ActionSelect.displayName = 'ActionSelect';
export default ActionSelect;
//# sourceMappingURL=ActionSelect.js.map